<template>
    <li role="presentation" :class="{ 'active': isActive }">
        <tab-button :href="href">
            <slot></slot>
        </tab-button>
    </li>
</template>

<script type="text/babel">
export default {
    props: ['name' , 'activeTab'],
    computed: {
        href() {
            return '#' + this.name
        },
        isActive() {
            return this.name === this.activeTab
        }
    }
}
</script>
